export function buildBasicAuthorizationHeader(token: string): string {
  const credentials = `switch:${token}`;
  if (typeof btoa === "function") {
    return `Basic ${btoa(credentials)}`;
  }

  const maybeBuffer = (globalThis as { Buffer?: { from: (v: string, e: string) => { toString: (e: string) => string } } }).Buffer;
  if (maybeBuffer) {
    return `Basic ${maybeBuffer.from(credentials, "utf-8").toString("base64")}`;
  }

  throw new Error("No base64 encoder available for Basic auth header");
}
